import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchMainProjects = ({ accountId, branchId, from, to, showAllBranches }) =>
  get(`/accounts/${accountId}/branches/${branchId}/main-projects`, { from, to, showAllBranches });

export const fetchMainProject = ({ accountId, branchId, mainProjectId }) =>
  get(`/accounts/${accountId}/branches/${branchId}/main-projects/${mainProjectId}`);

export const createMainProject = ({ accountId, branchId, name, startDate, endDate, color, metadata, projectIds }) =>
  post(`/accounts/${accountId}/branches/${branchId}/main-projects`, {
    name,
    startDate,
    endDate,
    color,
    metadata,
    projectIds
  });

export const updateMainProject = ({ accountId, branchId, mainProjectId, ...fields }) =>
  patch(`/accounts/${accountId}/branches/${branchId}/main-projects/${mainProjectId}`, fields);

export const deleteMainProject = ({ accountId, branchId, mainProjectId }) =>
  httpDelete(`/accounts/${accountId}/branches/${branchId}/main-projects/${mainProjectId}`);

export const linkProjectsToMainEvent = ({ accountId, branchId, mainProjectId, projectIds }) =>
  post(`/accounts/${accountId}/branches/${branchId}/main-projects/${mainProjectId}/link-projects`, { projectIds });

export const fetchMainProjectLiveView = ({ accountId, branchId, mainProjectId, date }) =>
  get(
    `/accounts/${accountId}/branches/${branchId}/main-projects/${mainProjectId}/live-view`,
    date ? { date } : undefined
  );
